import React, { FC } from 'react';
import { Layout } from 'antd';

import Profile from './Profile';
import SelectBusiness from './SelectBusiness';

const DesktopHeader: FC = () => {
  return (
    <Layout.Header className="DesktopHeader">
      <SelectBusiness />
      <div className="DesktopHeader-Actions">
        <Profile />
      </div>
    </Layout.Header>
  );
};

export default DesktopHeader;
